import React from 'react';
import Services from '../components/Services/Services';
import WhatsAppButton from '../components/WhatsAppButton/WhatsAppButton';
import './ServicesPage.css';

/**
 * Page Services - Page dédiée aux services de Wote
 */
function ServicesPage() {
  return (
    <div className="services-page">
      <div className="services-page-header">
        <div className="container">
          <div
            className="page-header-banner"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/female1.png)`,
            }}
          >
            <h1 className="page-title">Nos Services</h1>
            <p className="page-subtitle">
              Développement, accompagnement, formation et conseil pour vos projets technologiques
            </p>
          </div>
        </div>
      </div>

      <Services />

      {/* Section CTA */}
      <section className="services-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Prêt à démarrer votre projet ?</h2>
            <p className="cta-description">
              Contactez-nous dès maintenant pour discuter de vos besoins
            </p>
            <WhatsAppButton />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ServicesPage;

